// extracted by mini-css-extract-plugin
export var button = "HeroSmall-module--button--dea95";
export var container = "HeroSmall-module--container--f405f";
export var dark = "HeroSmall-module--dark--a121c";
export var gradient = "HeroSmall-module--gradient--e7de8";
export var gradients = "HeroSmall-module--gradients--fd51e";
export var heading = "HeroSmall-module--heading--94065";
export var light = "HeroSmall-module--light--b56bc";
export var paragraph = "HeroSmall-module--paragraph--ff105";
export var section = "HeroSmall-module--section--6c512";